import type { VideoAnalyticsContext } from '@ghl-revex/assets-drm-client/setup'

export interface CommunitiesVideoAnalyticsContextInput {
  locationId?: string
  contactId?: string
  collectionId?: string
  groupId?: string
  itemId?: string
}

const toOptionalString = (value: string | undefined): string | undefined => {
  const normalized = value?.trim()
  return normalized || undefined
}

/** Builds tenant and Communities placement context consumed by assets-drm analytics. */
export function buildCommunitiesVideoAnalyticsContext(input: CommunitiesVideoAnalyticsContextInput): VideoAnalyticsContext {
  const placement: NonNullable<VideoAnalyticsContext['placement']> = {
    surface: 'communities.lesson-video',
  }
  const context: VideoAnalyticsContext = { placement }

  const collectionId = toOptionalString(input.collectionId)
  const groupId = toOptionalString(input.groupId)
  const itemId = toOptionalString(input.itemId)
  const locationId = toOptionalString(input.locationId)
  const contactId = toOptionalString(input.contactId)

  if (collectionId) placement.collectionId = collectionId
  if (groupId) placement.groupId = groupId
  if (itemId) placement.itemId = itemId
  if (locationId) context.locationId = locationId
  if (contactId) context.contactId = contactId

  return context
}
